import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  // List of allowed emails (you can make this an environment variable)
  const ALLOWED_EMAILS = [
    'navnitsuman@gmail.com',
    'vinitchhotu23@gmail.com',
    'hemanta.hazarika@gmail.com',
    'joyeetaboruah@gmail.com',
    'navnitexamanalyst@gmail.com',
    'demoanalyticbyte@gmail.com',
    'biswab2002@gmail.com',
    // Add more emails as needed
  ];

  const handleSuccess = (credentialResponse) => {
    console.log('Login Success:', credentialResponse);
    setError('');
    
    if (credentialResponse && credentialResponse.credential) {
      try {
        // Decode JWT token
        const base64Url = credentialResponse.credential.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const userInfo = JSON.parse(jsonPayload);
        console.log('User Info:', userInfo);

        // Check if email is in allowed list
        const userEmail = userInfo.email.toLowerCase();
        const isEmailAllowed = ALLOWED_EMAILS.some(allowedEmail => 
          allowedEmail.toLowerCase() === userEmail
        );

        if (!isEmailAllowed) {
          setError(`Access denied. Email ${userEmail} is not authorized.`);
          localStorage.removeItem('google_token');
          localStorage.removeItem('user_info');
          return;
        }

        // Store token and user info
        localStorage.setItem('google_token', credentialResponse.credential);
        localStorage.setItem('user_info', JSON.stringify(userInfo));
        navigate('/dashboard');
        
      } catch (error) {
        console.error('Error parsing token:', error);
        setError('Error processing login. Please try again.');
      }
    }
  };

  const handleError = () => {
    console.log('Login Failed');
    setError('Login failed. Please try again.');
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Restricted Access</h2>
        <p className="login-subtitle">
          This application requires authorized Google account access.
        </p>
        
        {error && (
          <div className="alert alert-error">
            <span>⚠️</span>
            <span>{error}</span>
          </div>
        )}
        
        <div className="google-login-wrapper">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            useOneTap={false}
            theme="filled_blue"
            size="large"
            text="signin_with"
            shape="rectangular"
            width="300"
          />
        </div>
        
        <div className="login-info mt-4">
          <h4>Access Information:</h4>
          <ul>
            <li>Only authorized Google accounts can access this application</li>
            <li>Contact administrator for access requests</li>
            <li>Your email will be verified against our whitelist</li>
          </ul>
        </div>
        
        <div className="login-footer">
          <p>
            <small>
              Access is restricted to authorized personnel only. 
              Unauthorized attempts may be logged.
            </small>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;